jQuery(document).ready(function($) {
  
  // FOR PRICING SLIDER ON COLLECTION PAGE
  const minPrice = 0;
    const maxPrice = 100;

    const $fromInput = $('input[name="filter.v.price.gte"]');
    const $toInput = $('input[name="filter.v.price.lte"]');

    // Create the slider div and insert it before the price inputs
    const $slider = $('<div id="price-slider" style="margin: 10px 0;"></div>');
    $('.faceted-filter-group-display__price-range').before($slider);

    // Initialize jQuery UI slider
    $slider.slider({
      range: true,
      min: minPrice,
      max: maxPrice,
      step: 1,
      values: [minPrice, maxPrice],
      slide: function (event, ui) {
        $fromInput.val(ui.values[0]);
        $toInput.val(ui.values[1]);
      }
    });

    // Sync if user types manually
    $fromInput.on('input', function () {
      let fromVal = parseInt($(this).val()) || minPrice;
      let toVal = parseInt($toInput.val()) || maxPrice;
      $slider.slider("values", [fromVal, toVal]);
    });

    $toInput.on('input', function () {
      let fromVal = parseInt($fromInput.val()) || minPrice;
      let toVal = parseInt($(this).val()) || maxPrice;
      $slider.slider("values", [fromVal, toVal]);
    });
  
  
  // FOR TEXT TO COLORS ON COLLECTIOON PAGE FILTERS
  $('.faceted-filter-group').each(function () {
    const htmlContent = $(this).html();
    if (/Color/.test(htmlContent)) {
      $(this).addClass('for-color');
    }
  });

  
  const fallbackColors = {
    "Light Blue": "lightblue",
    "Dark Red": "darkred",
    "Sky": "skyblue",
    "Navy": "navy",
    "Charcoal": "#36454F",
    "Maroon": "maroon",
    "Off White": "#f8f8f8",
    "Cream": "#fffdd0",
    "Grey": "gray",
    "Ash": "#B2BEB5",
    // Add more custom mappings if needed
  };
  
  $('.for-color input[type="checkbox"]').each(function () {
    let val = $(this).val().trim().toLowerCase();
    let color;
  
    // Try using the value directly
    if (isValidColor(val)) {
      color = val;
    } else {
      // Try matching known fallbacks
      for (const key in fallbackColors) {
        if (val.includes(key.toLowerCase())) {
          color = fallbackColors[key];
          break;
        }
      }
    }
  
    if (color) {
      $(this).css({
        backgroundColor: color,
        border: "2px solid #ccc" // optional for contrast
      });
    }
  });
  
  // Helper to check if a string is a valid CSS color
  function isValidColor(strColor) {
    const s = new Option().style;
    s.color = strColor;
    return s.color !== '';
  }

  // CART OPEN CLOSE
  $(".cart-icon").on("click", function () {
      $(".cart-container").addClass("active");
  });
  $(".close-cart").on("click", function () {
      $(".cart-container").removeClass("active");
      $(".cart-container").removeClass("active_link");
  });

  // TO OPEN CART WHEN CLICK ON ADD TO CART
  $("button.add_to_cart.global-button.global-button--secondary.ajax-submit").on("click", function () {
      setTimeout(function () {
        $(".cart-container").addClass("active");
      }, 1000);
  });
  

  // FOR LEFT MARGIN ON SLIDERS

  if ($(window).width() > 1037) {
      var body = $("body").outerWidth();
      var contain = $("footer .container").innerWidth();
      var less = body - contain;
      var total = less / 2;
  }
  else if ($(window).width() < 1037 && $(window).width() > 767)  {
    var total = 20;
  }
  else {
    var total = 10;
  }

    $(".collection-slider .container-fluid").css('margin-left', total);
    $(".product-slider .container-fluid").css('margin-left', total);
    $(".blog-slider .container-fluid").css('margin-left', total);
    $(".tabs-slider .container-fluid .tabs-content").css('margin-left', total);
    $(".testimonials .container-fluid").css('margin-left', total);
    $(".content-slider .container-fluid").css('margin-left', total);

  // COLLECTION SLIDER SECTION
  
	var owl = $(".collection-slider .owl-carousel");
	  owl.owlCarousel({
		items: 4,
		margin: 30,
		loop: true,
		nav: true,
		responsive: {
		  0: {
			items: 1,
    		margin: 20
		  },
		  768: {
			items: 2,
      		margin: 20
		  },
		  1037: {
			items: 4,
      		margin: 30
		  }
		},
		autoplay: false,
		dots: false,
		navText: ["<i class='fa-solid fa-chevron-left'></i>", "<i class='fa-solid fa-chevron-right'></i>"]
	  });

  // CONTENT SLIDER SECTION
  
	var owl5 = $(".content-slider .owl-carousel");
	  owl5.owlCarousel({
		items: 2.5,
		margin: 20,
		loop: true,
		nav: true,
		responsive: {
		  0: {
			items: 1.2
		  },
		  768: {
			items: 1.5
		  },
		  1037: {
			items: 2.5
		  }
		},
		autoplay: false,
		dots: false,
		navText: ["<i class='fa-solid fa-chevron-left'></i>", "<i class='fa-solid fa-chevron-right'></i>"]
	  });  

  // VIDEO SECTION

  $('section.video .container .video-wrapper .overlay svg').on('click', function() {
    var video = $('section.video .container .video-wrapper video')[0];
    video.play();
    $('section.video .container .video-wrapper .overlay').hide();
  });
  $('section.video .container .video-wrapper video').on('pause', function() {
    $('section.video .container .video-wrapper .overlay').show();
  });

  // Blog SLIDER

	var owl20 = $(".blog-slider.owl-carousel");
	  owl20.owlCarousel({
		items: 3.25,
		margin: 30,
		loop: true,
		nav: true,
		responsive: {
		  0: {
			items: 1.25,
    		margin: 20
		  },
		  768: {
			items: 2.25,
      		margin: 20
		  },
		  1037: {
			items: 3.25,
      		margin: 30
		  }
		},
		autoplay: false,
		dots: false,
		navText: ["<i class='fa-solid fa-chevron-left'></i>", "<i class='fa-solid fa-chevron-right'></i>"]
	  });

  // PRODUCT SLIDER

	var owl2 = $(".product-slider.owl-carousel");
	  owl2.owlCarousel({
		items: 4.25,
		margin: 30,
		loop: true,
		nav: true,
		responsive: {
		  0: {
			items: 1.25,
    		margin: 20
		  },
		  768: {
			items: 2.25,
      		margin: 20
		  },
		  1037: {
			items: 4.25,
      		margin: 30
		  }
		},
		autoplay: false,
		dots: false,
		navText: ["<i class='fa-solid fa-chevron-left'></i>", "<i class='fa-solid fa-chevron-right'></i>"]
	  });

    $('.product-slider .item').each(function() {
        let $item = $(this);
        $item.find('.image-box img').hide();
        $item.find('.image-box img.image-1').show();
        $item.find('.dots img').on('click', function() {
            let clickedClass = $(this).attr('class');
            $item.find('.image-box img').hide();
            $item.find('.image-box img.' + clickedClass).show();
        });
    });

  // EDITOR PICK SLIDER

	var owl2 = $(".editor-pick-slider.owl-carousel");
	  owl2.owlCarousel({
		items: 3,
		margin: 20,
		loop: true,
		nav: false,
		responsive: {
		  0: {
			items: 1,
    		margin: 20
		  },
		  768: {
			items: 2,
      		margin: 20
		  },
		  1037: {
			items: 3,
      		margin: 20
		  }
		},
		autoplay: false,
		dots: true,
		navText: ["<i class='fa-solid fa-chevron-left'></i>", "<i class='fa-solid fa-chevron-right'></i>"]
	  });

    $('.editor-pick-slider .item').each(function() {
        let $item = $(this);
        $item.find('.image-box img').hide();
        $item.find('.image-box img.image-1').show();
        $item.find('.dots img').on('click', function() {
            let clickedClass = $(this).attr('class');
            $item.find('.image-box img').hide();
            $item.find('.image-box img.' + clickedClass).show();
        });
    });

  // TESTIMONIALS SECTION
  var owl3 = $(".testimonials .owl-carousel");
	  owl3.owlCarousel({
		items: 2.5,
		margin: 20,
		loop: true,
		nav: false,
		responsive: {
		  0: {
			items: 1.12
		  },
		  768: {
			items: 1.5
		  },
		  1037: {
			items: 2.5
		  }
		},
		autoplay: false,
		dots: false
	  });

  // FOOTER SLIDER MOBILE
  var owl4 = $("footer .top-mobile.owl-carousel");
	  owl4.owlCarousel({
		items: 1,
		margin: 0,
		loop: true,
		nav: true,
		autoplay: true,
		dots: false
	  });

  // FOOTER MENU ACCORDION
  $(".accordion_head").click(function () {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('-');
        }
    });

  // ACCORDION
  $('.accordion-list > li > .answer').hide();
  $('.accordion-list > li').click(function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active").find(".answer").slideUp();
    } else {
      $(".accordion-list > li.active .answer").slideUp();
      $(".accordion-list > li.active").removeClass("active");
      $(this).addClass("active").find(".answer").slideDown();
    }
    return false;
  });

  // FOR COLLECTION PAGE VIEW TOGGLE
  $(document).on("click", ".custom-collection .section_select .custom-filters .view-as .icons img", function() {
    if (!$(this).hasClass("active")) {
      $(".custom-collection .section_select .custom-filters .view-as .icons img").removeClass("active");
      $(this).addClass("active");
      $(".product-list--collection").toggleClass("horizontal");
    }
  });

  // FOR ADDING ACTIVE CLASS ON NAV ON COLLECTION PAGE
  // Get the current page URL
  var currentPage = window.location.pathname;

  // Loop through all links in the collection-nav
  $('.collection-nav a').each(function() {
    // Check if the href of the link matches the current page URL
    if ($(this).attr('href') === currentPage) {
      // Add the 'active' class to the matching link
      $(this).addClass('active');
    }
  });

  // FOR OPEN AND CLOSE COLLECTION FILTERS
  // When .filter-toggle is clicked, add the active class to .sidebar
  $('.filter-toggle').on('click', function() {
    $('.sidebar').addClass('active');
  });

  // When .filter-toggle-ckise is clicked, remove the active class from .sidebar
  $('.filter-toggle-close').on('click', function() {
    $('.sidebar').removeClass('active');
  });

  // PRODUCT COLLECTION GRID DETAILS INTO A DIV
  $('.one-third').each(function() {
    $(this).find('.product-info__caption, .collection_swatches').wrapAll('<div class="bottomm"></div>');
  });

  // PRODUCT PAGE PAIRS WELL WITH SLIDER
  var owl8 = $(".pairs-well-with .owl-carousel");
  	  owl8.owlCarousel({
  		items: 1,
  		margin: 0,
  		loop: true,
  		nav: false,
  		autoplay: false,
  		dots: true
  });

  // BOG SLIDER CONTENT EQUAL HEIGHT
  var maxHeight = 0;
  $(".blog-slider .content-box").each(function () {
      var currentHeight = $(this).height();
      if (currentHeight > maxHeight) {
          maxHeight = currentHeight;
      }
  });
  $(".blog-slider .content-box").height(maxHeight);

  // PRODUCT SINGLE IMAGES
  var owl33 = $(".product-images .owl-carousel");
  	  owl33.owlCarousel({
      items: 4,
      margin: 10,
      nav: true,
      dots: false,
      loop: true
    });

    // On thumbnail click
    $(".thumbnail-img").on("click", function() {
      var index = $(this).data("image-index");

      // Hide all and show selected
      $(".main-img").removeClass("active").addClass("hidden");
      $('.main-img[data-image-index="' + index + '"]').addClass("active").removeClass("hidden");
    });
  
});

// MARQUEE SECTION
// document.addEventListener("DOMContentLoaded", function() {
//   let marquee = document.querySelector(".marquee .marquee-inner");
//   let clone = marquee.innerHTML;
//   marquee.innerHTML += clone;
// });
document.addEventListener("DOMContentLoaded", function () {
  const marquee = document.querySelector(".marquee .marquee-inner");

  if (marquee) {
    const clone = marquee.innerHTML;
    marquee.innerHTML += clone;
  }
});

// TABS SLIDER SECTION


/* Versa cap: keep the selected colour and gallery image in sync */
document.addEventListener("DOMContentLoaded", function () {
  const productId = "10348914016532";
  const galleryNav = document.querySelector(".product-" + productId + "-gallery-nav");

  if (!galleryNav) return;

  const mediaByColour = {
    Black: "46768297705748",
    Sage: "46768297738516",
    Bone: "46768297771284",
    Navy: "46768793780500"
  };

  function showColourImage(colour) {
    const mediaId = mediaByColour[colour];
    if (!mediaId) return;

    const thumbnail = galleryNav.querySelector(
      '.gallery-cell[data-media-id="' + mediaId + '"]'
    );

    if (thumbnail) {
      window.setTimeout(function () {
        thumbnail.click();
      }, 0);
    }
  }

  document
    .querySelectorAll('input[type="radio"][id*="-' + productId + '-"]')
    .forEach(function (input) {
      input.addEventListener("change", function () {
        if (this.checked) showColourImage(this.value);
      });
    });
});
document.addEventListener("DOMContentLoaded", function() {
  let tabs = document.querySelectorAll("section.tabs-slider .tab-btn");
  let contents = document.querySelectorAll("section.tabs-slider .tab-content");
  tabs.forEach((tab, index) => {
    tab.addEventListener("click", function() {
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));
      this.classList.add("active");
      document.querySelector("section.tabs-slider .tab-" + (index + 1)).classList.add("active");
    });
  });
  if (tabs.length > 0) {
    tabs[0].classList.add("active");
    contents[0].classList.add("active");
  }
});

// INSTAGRAM SECTION
document.addEventListener("DOMContentLoaded", function() {
  let instagram = document.querySelector(".instagram .instagram-inner");
  if (!instagram) return;
  let clone = instagram.innerHTML;
  instagram.innerHTML += clone;
});

// FOR HEADER SEARCH
document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.querySelector("header .search input");
    const searchButton = document.querySelector("header .search button");
    searchButton.addEventListener("click", function () {
        performSearch();
    });
    searchInput.addEventListener("keypress", function (event) {
        if (event.key === "Enter") {
            performSearch();
        }
    });
    function performSearch() {
        const query = searchInput.value.trim();
        if (query !== "") {
            window.location.href = `/search?q=${encodeURIComponent(query)}`;
        }
    }
});

// HEADER MEGA MENU
jQuery(document).ready(function ($) {

    $("header .header .navigation .nav-item.has-submenu").hover(
      function () {
        // Remove 'active' class from all nav items and submenus
        $("header .header .navigation .nav-item.has-submenu").removeClass("active");
        $("header .header .navigation .nav-item.has-submenu .submenu").removeClass("active");
    
        // Add 'active' class to the hovered nav item and its submenu
        $(this).addClass("active");
        $(this).find("> .submenu").addClass("active");
      }
    );
    
    // Remove active class only when leaving the entire header
    $("header").mouseleave(function () {
      $("header .header .navigation .nav-item.has-submenu").removeClass("active");
      $("header .header .navigation .nav-item.has-submenu .submenu").removeClass("active");
    });

  
    // Language Switcher
    $(".language-switcher select").change(function () {
        var langUrl = $(this).val();
        localStorage.setItem("selectedLang", langUrl);
        window.location.href = langUrl;
    });

    // Preserve selected language from localStorage
    var savedLang = localStorage.getItem("selectedLang");
    if (savedLang) {
        $(".language-switcher select").val(savedLang);
    }

  // Currency Switcher
    $(".currency-switcher select").change(function () {
        var selectedCurrency = $(this).val();
        var newUrl = new URL(window.location.href);
        newUrl.searchParams.set("currency", selectedCurrency);
        window.location.href = newUrl.toString();
    });

    // Preserve selected currency
    var urlParams = new URLSearchParams(window.location.search);
    var currencyParam = urlParams.get("currency");
    if (currencyParam) {
        $(".currency-switcher select").val(currencyParam);
    }

});

$(".nav-item.has-submenu > a, .sub-nav-item.has-submenu > a").on("click", function (e) {
    e.preventDefault();
    var parentItem = $(this).parent();
    parentItem.addClass("active").siblings().removeClass("active");
    parentItem.children(".submenu").addClass("active");
});

$(".back-mobile-nav").on("click", function () {
    var currentSubmenu = $(this).closest(".submenu");
    currentSubmenu.removeClass("active");
    currentSubmenu.closest(".nav-item, .sub-nav-item").removeClass("active");
});

$(".icons a.menu-icon").on("click", function () {
    $(".mobile-nav-wrapper").addClass("active");
});

$(".close-mobile-nav").on("click", function () {
    $(".mobile-nav-wrapper").removeClass("active");
});


// Fit guide popup
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.fit-guide-btn').forEach(button => {
    const id = button.getAttribute('data-popup-id');
    const popup = document.getElementById(id);
    const close = popup.querySelector('.fit-guide-close');

    button.addEventListener('click', () => popup.classList.add('active'));
    close.addEventListener('click', () => popup.classList.remove('active'));
    popup.addEventListener('click', e => {
      if (e.target === popup) popup.classList.remove('active');
    });
  });
});

// Size chart popup
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.size-chart-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.nextElementSibling.style.display = 'flex';
    });
  });

  document.querySelectorAll('.size-chart-close').forEach(close => {
    close.addEventListener('click', () => {
      close.closest('.size-chart-popup').style.display = 'none';
    });
  });

document.querySelectorAll('.size-chart-toggle').forEach(toggle => {
  const block = toggle.closest('.size-chart-wrapper');
  const metricInput = toggle.querySelector('input#metric');
  const imperialInput = toggle.querySelector('input#imperial');

  metricInput.addEventListener('change', () => {
    block.querySelector('.metric').classList.add('active');
    block.querySelector('.imperial').classList.remove('active');
  });

  imperialInput.addEventListener('change', () => {
    block.querySelector('.imperial').classList.add('active');
    block.querySelector('.metric').classList.remove('active');
  });
});

});

/*
// Color swtach scrit jacket product only
document.addEventListener('DOMContentLoaded', () => {
  // Loop through each variant section
  document.querySelectorAll('.custom-variant-selector').forEach(section => {
    const colorLabel = section.querySelector('.color-label span');
    const swatches = section.querySelectorAll('.color-swatch');

    // Get saved variant from localStorage
    const savedVariant = localStorage.getItem('selected_variant');

    // Set initial label
    if (savedVariant) {
      colorLabel.textContent = 'Color: ' + savedVariant;
    } else {
      colorLabel.textContent = 'Color:';
    }

    // Mark active swatch
    swatches.forEach(swatch => {
      if (swatch.dataset.variantName === savedVariant) {
        swatch.classList.add('active');
      } else {
        swatch.classList.remove('active');
      }
    });

    // Hover effect
    swatches.forEach(swatch => {
      swatch.addEventListener('mouseenter', () => {
        colorLabel.textContent = 'Color: ' + swatch.dataset.variantName;
      });

      swatch.addEventListener('mouseleave', () => {
        // Restore saved variant after hover
        const saved = localStorage.getItem('selected_variant');
        colorLabel.textContent = saved ? 'Color: ' + saved : 'Color:';
      });

      // On click: save selected variant and update label
      swatch.addEventListener('click', () => {
        const variantName = swatch.dataset.variantName;
        localStorage.setItem('selected_variant', variantName);
        colorLabel.textContent = 'Color: ' + variantName;

        // Update active border immediately
        swatches.forEach(s => s.classList.remove('active'));
        swatch.classList.add('active');
      });
    });
  });
});
*/

// All variant swatch label after the color label
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.swatch').forEach(swatchGroup => {
  
    const optionTitle = swatchGroup.querySelector('.option_title');
    if (!optionTitle) return;
    const optionName = optionTitle.textContent.trim(); 
    const swatchElements = swatchGroup.querySelectorAll('.swatch-element');
    const optionIndex = swatchGroup.dataset.optionIndex;
    const savedVariant = localStorage.getItem('selected_variant_' + optionIndex);
    if (savedVariant) {
      optionTitle.textContent = optionName + ': ' + savedVariant;
      swatchElements.forEach(el => {
        if (el.dataset.value === savedVariant) el.classList.add('active');
      });
    }

    swatchElements.forEach(swatch => {
      swatch.addEventListener('mouseenter', () => {
        optionTitle.textContent = optionName + ': ' + swatch.dataset.value;
      });

      swatch.addEventListener('mouseleave', () => {
        const saved = localStorage.getItem('selected_variant_' + optionIndex);
        optionTitle.textContent = optionName + (saved ? ': ' + saved : '');
      });

      swatch.addEventListener('click', () => {
        const value = swatch.dataset.value;
        localStorage.setItem('selected_variant_' + optionIndex, value);

        swatchElements.forEach(el => el.classList.remove('active'));
        swatch.classList.add('active');

        optionTitle.textContent = optionName + ': ' + value;
      });
    });
  });
});


$('.desktop-header .navigation .has-submenu > a').on('click', function(e) {
    const link = $(this).attr('href');

    // if real link → allow navigation
    if (link && link !== '#') {
        window.location.href = link;
    } else {
        e.preventDefault();
        $(this).parent().toggleClass('active');
    }
});


var totalHeaderHeight = 0;

function updateHeaderHeight() {
    var mainHeader = $('header.desktop-header .header').outerHeight() || 0;
    var announcement = $('.announcement').outerHeight() || 0;

    totalHeaderHeight = mainHeader - announcement + 20;
}

$(document).ready(updateHeaderHeight);
$(window).on('resize', updateHeaderHeight);

$(window).on('scroll', function () {
    var scroll = $(window).scrollTop();
    var header = $('header.desktop-header .header');

    if ($(window).width() >= 1037) {

        if (scroll > totalHeaderHeight) {
            header.addClass('is-absolute');
            $('header').addClass('sticky-active');
        } else {
            header.removeClass('is-absolute');
            $('header').removeClass('sticky-active');
        }

    } else {
        header.removeClass('is-absolute');
        $('header').removeClass('sticky-active');
    }
});


// mobile header
document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('header.mobile-header');
    if (!header) return;

    let totalHeaderHeight = 0;

    function updateHeaderHeight() {
        const mainHeader = document.querySelector('header.mobile-header .header');
        const announcement = document.querySelector('.announcement');

        const mainHeight = mainHeader ? mainHeader.offsetHeight : 0;
        const announcementHeight = announcement ? announcement.offsetHeight : 0;

        totalHeaderHeight = mainHeight - announcementHeight;
    }

    // Initial calc
    updateHeaderHeight();

    // Recalculate on resize
    window.addEventListener('resize', updateHeaderHeight);

    // Scroll logic
    window.addEventListener('scroll', function () {
        if (window.scrollY > totalHeaderHeight) {
            header.classList.add('sticky-active');
        } else {
            header.classList.remove('sticky-active');
        }
    });
});